import { render, staticRenderFns } from "./settled-in.vue?vue&type=template&id=757d746a&"
var script = {}
import style0 from "./settled-in.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports